"use strict";
(self["webpackChunkFirmSupport"] = self["webpackChunkFirmSupport"] || []).push([[7374],{

/***/ 97374:
/***/ ((module) => {

module.exports = JSON.parse('{"PERSON":"Person","SOLE_PROPRIETORSHIP":"Sole Proprietorship","LIMITED_COMPANY":"Limited company/Economic association","PARTNERSHIP":"Partnership/Limited partnership","NON_PROFIT_ASSOCIATION":"Non-profit association/Foundation"}');

/***/ })

}]);